export default __webpack_public_path__ + "static/media/time-add-client-employee.8dbd2c81.png";